export const AdvisorComparisonStrategyPanel = ({ strategy }) => {
  if (!strategy) return null;

  return (
    <div className="rounded-[22px] border border-[#D4AF37]/25 bg-[#fffdf8] px-4 py-4 shadow-[0_10px_26px_rgba(0,25,53,0.06)]" data-testid="signature-advisor-comparison-strategy-panel">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#8b6d16]" data-testid="signature-advisor-comparison-strategy-eyebrow">AI comparison strategist</p>
      <h4 className="mt-2 text-lg font-semibold text-[#001935]" data-testid="signature-advisor-comparison-strategy-headline">{strategy.headline}</h4>
      <p className="mt-2 text-sm leading-7 text-[#5f5a4e]" data-testid="signature-advisor-comparison-strategy-summary">{strategy.summary}</p>

      <div className="mt-4 grid gap-3 md:grid-cols-3" data-testid="signature-advisor-comparison-strategy-card-grid">
        {strategy.cards?.map((card, index) => (
          <div className="rounded-[18px] border border-[#D4AF37]/20 bg-white px-4 py-4" data-testid={`signature-advisor-comparison-strategy-card-${index + 1}`} key={`${card.label}-${index}`}>
            <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]">{card.label}</p>
            <p className="mt-2 text-sm font-semibold leading-6 text-[#001935]">{card.value}</p>
            <p className="mt-2 text-sm leading-6 text-[#5f5a4e]">{card.rationale}</p>
          </div>
        ))}
      </div>
    </div>
  );
};